// extracted by mini-css-extract-plugin
export var actionButton = "_cm-t";
export var buttonContainer = "_cm-0";
export var buttonContainer2 = "_cm-1";
export var buttonSection = "_cm-2";
export var details = "_cm-3";
export var dropdownItem = "_cm-5";
export var dropdownItemsContainer = "_cm-4";
export var fileInput = "_cm-r";
export var headerButton = "_cm-6";
export var icon = "_cm-7";
export var input = "_cm-8";
export var macroListItem = "_cm-9";
export var mainContent = "_cm-a";
export var microText = "_cm-b";
export var modal = "_cm-w";
export var optionsButton = "_cm-c";
export var paperclip = "_cm-s";
export var pillContent = "_cm-d";
export var preview = "_cm-e";
export var preview2 = "_cm-f";
export var quillEditor = "_cm-q";
export var selectedMacro = "_cm-g";
export var sidebar = "_cm-h";
export var sidebarHeader = "_cm-j";
export var sidebarList = "_cm-i";
export var sidebarListItem = "_cm-k";
export var sidebarSearch = "_cm-l";
export var snoozeDurationWrapper = "_cm-v";
export var statusPillContainer = "_cm-m";
export var tagsContainer = "_cm-n";
export var unselectedMacro = "_cm-o";
export var variable = "_cm-u";
export var wrapper = "_cm-p";